import LegalPageLayout from './LegalPageLayout';
import { PrivacyContent } from './privacy-content';

export default function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Privacy Notice" lastUpdated="January 16, 2026">
      <PrivacyContent />
    </LegalPageLayout>
  );
}
